<article class="ciMapTransport fadein animation-duration-500 relative overflow-hidden hidden"
          [ngClass]="{'flex flex-column': !showPrices}">
  <section *ngIf="mapId" [id]="mapId" class="z-3 w-full h-full"></section>

  <section class="w-fit absolute top-0 left-0 p-3 gap-2 flex justify-content-center align-items-center">
    <div
      class="w-fit border-round-xl px-2 flex flex-column align-items-center shadow-3 bg-white-alpha-80 z-5 fadein animation-duration-500 relative">
      <section class="w-full">
        <section class="w-full">
          <section class="w-full flex justify-content-between align-items-center gap-4">
            <small class="ci-txt--black-lighten">Partida</small>
            <i class="bi bi-slash-lg text-3xl ci-txt--green-traffic rotate-45"></i>
          </section>

          <section class="w-full flex justify-content-between align-items-center -mt-2 gap-4">
            <small class="ci-txt--black-lighten">Retorno</small>
            <i class="bi bi-slash-lg text-3xl ci-txt--red-traffic rotate-45"></i>
          </section>
        </section>
      </section>

      <section class="w-full border-1 border-bottom-1 border-gray-300">
      </section>

      <section class="w-full flex flex-column py-1">
        <small class="font-semibold ci-txt--black my-1">
          Tarifa gral.
        </small>

        <section>
          <span class="ci-txt--grey py-1 font-bold text-xl">
            2.50Bs
          </span>
        </section>

        <section class="ci-bg--grey cursor-pointer flex justify-content-center border-round mb-1 mt-2" (click)="showPrices = true">
          <small class="ci-txt--white py-1">
            Ver pasajes
          </small>
        </section>
      </section>
    </div>
  </section>

  <section class="w-full z-4 relative flex flex-column shadow-1">
    <section class="w-full p-3 pr-0 pb-0">
      <section class="w-screen sm:w-full flex align-items-center">
        <section *ngIf="selectedLine?.line" class="sticky left-0 border-right-2 pr-2 mr-2 border-gray-300">
          <section
            class="ci-line-marked w-4rem h-4rem md:w-5rem md:h-5rem fadein animation-duration-500 ci-bg--yellow border-round-xl flex flex-column justify-content-center align-items-center relative">
            <p class="ci-txt--white">
              Línea
            </p>

            <h4 class="text-2xl ci-txt--white">
              {{selectedLine.line}}
            </h4>

            <section (click)="removeSelectedLine()"
              class="w-2rem h-2rem shadow-3 cursor-pointer ci-bg--white absolute -mt-3 -mr-3 top-0 right-0 border-round-3xl flex align-items-center justify-content-center ci-bg--cherry">
              <i class="bi bi-trash text-md ci-txt--white"></i>
            </section>
          </section>
        </section>

        <section *ngIf="filteredLines.length > 0" class="overflow-auto">
          <swiper-container slides-per-view="auto" free-mode="true">
            <swiper-slide *ngFor="let item of filteredLines, index as i" class="w-fit cursor-pointer mr-3"
              [ngClass]="{'hidden': item.line === selectedLine?.line}">
              <section
                class="w-4rem h-4rem md:w-5rem md:h-5rem fadein animation-duration-500 ci-bg--purple-lighten border-round-xl flex flex-column justify-content-center align-items-center"
                id="line-{{i}}" (click)="markLineRoute(item, i)"
                [ngClass]="{'ci-line-marked': item.line === selectedLine?.line}">
                <small class="ci-txt--white">
                  Línea
                </small>

                <h4 class="text-2xl ci-txt--white">
                  {{item.line}}
                </h4>
              </section>
            </swiper-slide>
          </swiper-container>
        </section>
      </section>

      <section *ngIf="(filteredLines.length === 0) && (!selectedLine)"
        class="h-4rem md:h-5rem px-3 bg-black-alpha-10 fadein animation-duration-500 flex flex-column justify-content-center align-items-center border-round-2xl">
        <p class="text-lg md:text-xl ci-txt--black-lighten flex align-items-center">
          <i class="bi bi-exclamation-diamond text-3xl md:text-4xl ci-txt--red mr-2"></i>

          No hay coincidencias con la búsqueda...
        </p>
      </section>
    </section>

    <section class="p-3">
      <section class="flex align-items-center border-round-xl px-2 border-1 shadow-1 border-gray-300 ci-bg--white">
        <section>
          <i class="bi bi-search text-lg ci-txt--black-lighten"></i>
        </section>

        <input type="text" placeholder="Busca una línea de transporte..." (focus)="onFocus()" (input)="onInputChange()"
          [(ngModel)]="searchQuery">

        <section *ngIf="searchQuery !== ''" (click)="clearInput()">
          <i class="bi bi-x-circle-fill text-lg ci-txt--grey cursor-pointer"></i>
        </section>
      </section>
    </section>
  </section>
</article>

<article *ngIf="showPrices" class="h-full w-auto fadeindown animation-duration-500">
  <section class="w-fit max-w-full max-h-full mx-auto md:w-30rem md:h-30rem">
    <img
      src="https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2FurbanMobility%2Fprices%2Fpasajes.jpg?alt=media&token=4d23773f-1877-4199-b5e3-526a9431c329"
      alt="Prices image"
      class="w-full h-auto max-w-full max-h-full object-contain">
  </section>

  <section class="ci-bg--grey cursor-pointer ci-txt--white ci-bg--yellow flex justify-content-center py-3" (click)="showPrices = false">
    Ver líneas de transporte
  </section>
</article>

<style>
  .ciMapTransport {
    width: 75rem;
    height: 50rem;
  }

  @media screen and (max-width: 1920px) {
    .ciMapTransport {
      width: 60rem;
      height: 35rem;
    }
  }

  @media screen and (max-width: 1024px) {
    .ciMapTransport {
      width: 100vw;
    }
  }

  @media screen and (max-width: 1024px) and (min-height: 601px) {
    .ciMapTransport {
      height: 60rem;
    }
  }


  @media screen and (max-width: 850px) {
    .ciMapTransport {
      height: 60rem;
    }
  }

  @media screen and (max-width: 768px) {
    .ciMapTransport {
      height: 50rem;
    }
  }

  @media screen and (max-width: 420px) {
    .ciMapTransport {
      height: 40rem;
    }
  }

  @media screen and (max-width: 390px) {
    .ciMapTransport {
      height: 46rem;
    }
  }

  @media screen and (max-width: 376px) {
    .ciMapTransport {
      height: 36rem;
    }
  }

  @media screen and (max-width: 320px) {
    .ciMapTransport {
      height: 30rem;
    }
  }
</style>